import { z } from "zod";

export const workspaceSchema = z.object({
  name: z.string().min(1, "Required"),
  visibility: z.enum(["public", "private"]),
  users: z.array(z.any()),
  aiKey: z.string().optional(),
});

export type WorkspaceFormValues = z.infer<typeof workspaceSchema>;
